// src/ui/Countries.js

export const COUNTRIES = [
  { code: "USA", name: "United States" },
  { code: "CAN", name: "Canada" },
  { code: "GBR", name: "United Kingdom" },

  // Europe
  { code: "DEU", name: "Germany" },
  { code: "FRA", name: "France" },
  { code: "NLD", name: "Netherlands" },
  { code: "CHE", name: "Switzerland" },
  { code: "ITA", name: "Italy" },
  { code: "ESP", name: "Spain" },
  { code: "SWE", name: "Sweden" },
  { code: "CZE", name: "Czech Republic" },

  // Asia-Pacific
  { code: "JPN", name: "Japan" },
  { code: "TWN", name: "Taiwan" },
  { code: "CHN", name: "China" },
  { code: "SGP", name: "Singapore" },
  { code: "KOR", name: "South Korea" },
  { code: "IND", name: "India" },
  { code: "AUS", name: "Australia" },
  { code: "NZL", name: "New Zealand" },

  // Americas
  { code: "MEX", name: "Mexico" },
  { code: "BRA", name: "Brazil" },
  { code: "ARG", name: "Argentina" },
  { code: "CHL", name: "Chile" },
];

// Convenience helpers (optional but useful)
export function getCountryName(code) {
  return COUNTRIES.find(c => c.code === code)?.name || code;
}
